export enum MassMessagingStatusEnum {
  CREATED_STATUS,
  STARTED_STATUS,
  COMPLETED_STATUS,
  CANCELLED_STATUS,
  ON_HOLD_STATUS, // manual pause
  WAITING_FOR_QUOTA, // technical pause
}
